import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import Content from './components/Content';
import * as S from './styled';

const UserHoverCard = ({ userId, children }) => {
  const [hovered, setHovered] = useState(false);
  const anchorId = `uhc-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;

  if (!userId) {
    return (
      <S.TooltipStyles>
        <S.Anchor as="span">{children}</S.Anchor>
      </S.TooltipStyles>
    );
  }

  const href = `/customer/users/${userId}`;

  // Rendered in place rather than portalled to the body: the shared Modal is a `wa-dialog` around
  // a native `<dialog>`, which paints in the browser's top layer. A tooltip outside of it ends up
  // behind the modal no matter how high its z-index is.
  const tooltip = (
    <S.TooltipStyles>
      <Tooltip
        anchorSelect={`#${anchorId}`}
        className="user-hover-tooltip"
        positionStrategy="fixed"
        clickable
        delayShow={200}
        delayHide={150}
        place="top"
        style={{ zIndex: 9999, padding: '6px 6px' }}
      >
        {hovered && <Content userId={userId} />}
      </Tooltip>
    </S.TooltipStyles>
  );

  return (
    <>
      <S.Anchor as={Link} to={href} id={anchorId} onMouseEnter={() => setHovered(true)}>
        {children}
      </S.Anchor>
      {tooltip}
    </>
  );
};

UserHoverCard.propTypes = {
  userId: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default UserHoverCard;
